import { UnstyledButton } from "@mantine/core";
import type { CSSProperties } from "react";
import { useNavigate } from "react-router-dom";

type SidebarLogoLinkProps = {
  to: string;
  height?: number;
  alt?: string;
  ariaLabel?: string;
  style?: CSSProperties;
  onNavigate?: () => void;
};

/** Clickable GTsetu logo for authenticated app sidebars. */
export function SidebarLogoLink({
  to,
  height = 38,
  alt = "GTsetu",
  ariaLabel = "Go to home",
  style,
  onNavigate,
}: SidebarLogoLinkProps) {
  const navigate = useNavigate();

  return (
    <UnstyledButton
      className="sidebar-logo-link"
      onClick={() => {
        navigate(to);
        onNavigate?.();
      }}
      aria-label={ariaLabel}
    >
      <img
        src="/gtLogo.svg"
        alt={alt}
        style={{
          height,
          width: "auto",
          maxHeight: height,
          objectFit: "contain",
          objectPosition: "left center",
          display: "block",
          ...style,
        }}
      />
    </UnstyledButton>
  );
}
